import { useProjectStore } from 'features/project/store'
import type { ProjectState } from 'types/project'

/**
 * Returns true once the global project store has been written with details
 * for the given projectId — i.e. useProjectDetails' setDetails effect has run
 * and the store reflects THIS hub (not a stale one from a previous visit).
 *
 * Extracted into a hook so ProjectRoot (a component) does not read the Zustand
 * store directly (view-store-hooks rule).
 */
export const useProjectStoreSynced = (projectId: string): boolean => {
  const storeDetails = useProjectStore((state: ProjectState) => state.details)
  return !!storeDetails && storeDetails.proj_uuid === projectId
}
